const sendEmail = (event, email: string ='') => {
    window.location.href = `mailto:support@nexchange.co.uk?subject=Request for registration in Easy Wallet&body=${email} I want to join EasyWallet`
}

export default sendEmail